import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import servicii from "../images/servicii-img.png";
import smallServicii from "../images/small-servicii.png";
import "../css/main.css";

const ConsilierePsihologica = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog servicii serviciu-page">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Consiliere Psihologică</h1>
          <p>
            Consilierea psihologica este o interventie orientatat spre resurse
            si centrata pe actiune care antreneaza abilitatea de a raspunde
            provocarilor vietii.
          </p>
          <p>
            Scopul consilierii este acela de a consolida autonomia clientului
            printr-o cunostere si intelegere mai buna a problemei cu care se
            confrunta, a resurselor de care are nevoie si cele pe care le
            detine, a capacitatii decizionale si a actiunii.
          </p>
          <div class="s-bubbles">
            <div class="s-bubble">ACTIUNE</div>
            <div class="s-bubble">OBIECTIVE</div>
            <div class="s-bubble">RESURSE</div>
            <div class="s-bubble">RESPONSABILITATE</div>
          </div>
          <p>
            In spatiul AWARE te putem sprijini, prin servicii de consiliere
            pentru a privi cu mai multa claritate spre problemele si
            dificultatile cu care te confruntii.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ConsilierePsihologica;
